import React, {Component} from 'react';
import ReportGeneralTable from '../report/ReportGeneralTable'
import StockStore from '../../stores/StockStore'
import FontAwesome from 'react-fontawesome';
import StockRequestDoc from './StockRequestDoc';
import Select from 'react-select'
import {connect} from 'react-redux'
import { Tabs, Tab } from 'react-bootstrap'

class StockRequestReport extends Component {

  
  constructor(...args){
    super(...args)
    this.state = {showTable:true,mpNo:'',doc:'',activeKey:1}
    this.qoTable = [null,null,null,null]
  }

  // renameDoc(newPoNo){
  //   this.refs.soDoc.renameDoc(newPoNo)
  // }

  componentWillReceiveProps(newProps){
    let {activeKey} = this.state
    if(newProps.show && newProps.show!==this.props.show){
      if (this.qoTable[activeKey-1]!==null || this.props.location!==newProps.location) {        
        this.qoTable[activeKey-1].refreshTable()
        this.setState({showTable:true})
      }   
    }
  }

  showTable(){
    let {activeKey} = this.state
    this.setState({showTable:true})
    if(this.qoTable[activeKey-1]!==null)
      this.qoTable[activeKey-1].refreshTable()  
    if(this.props.onTableShow!==undefined){
      this.props.onTableShow()
    }
  }

  onRowSelect(item){
    
    this.setState({showTable:false,mpNo:item.recordid,doc:item})
    
    
  }

  onDocNew(){
    this.setState({showTable:false,doc:{recordid:''}})
  }

  onDocClose(){
    this.showTable() 
  }

  loadData(year,month,day,searchBy,query,activePage,itemPerPage,callback){
    let {activeKey} = this.state
    let pr = ''
    if (activeKey===2)
      pr = '0'
    else if (activeKey===3)
      pr = '1'
    else if (activeKey===4)
      pr = '2'  
    StockStore.loadStockTransaction_('any',year-543,month,day,searchBy,'request_purchase',activePage*itemPerPage,itemPerPage,query,pr,callback)
  }

  getDate(added_date,type) {
    let date = added_date
    if (type==='day')
      date = date.substring(0, 10)
    else
      date = date.substring(11, 19)

    return date
  }

  renderItems(items) {
    if (items.length===0||items===undefined) {
      return ('')
    } else {
      return(
        items.map((item,index)=> {
          return(
            <div key={index}>
              <p>{' - ' + item.description + ' '+this.props.messages['Quantity']+' ' + item.quantity+' '+(item.unit!==''&&item.unit!==undefined&&item.unit!==null?item.unit:'รายการ')}</p>
            </div>
          )
        })
      )
    }
  }

  onTabsSelect(e){
    this.setState({activeKey:e})
  }

  onPrintClick(rid){
    if (process.env.NODE_ENV === "development") {
      window.open('https://demo2.bigfix.co/korat/pdf/?sr='+rid+'&file=stockrecord_doc', '_blank');
    } else{
      window.open('./pdf/?sr='+rid+'&file=stockrecord_doc', '_blank');
    }
  }

  onPRStatusChange(recordid,e) {
    let {activeKey} = this.state
    StockStore.updatePRStatus(recordid,e.value,(result)=>{
      if (result.status==='OK') {
        if (this.qoTable[activeKey-1]!==null)
          this.qoTable[activeKey-1].refreshTable()
      }
    })
  }

  onRenderColumn(data,col,row,index,sub_index){
    if (sub_index===0||sub_index===1) {
      let type = 'day'
      if (sub_index===1)
        type = 'time'
      return(<span>{this.getDate(row.added_date,type)}</span>)
    } else if (sub_index===2) {
      return(<span>{row.request_by}</span>)
    } else if (sub_index===3) {
      return(<span>{row.response_by}</span>)
    } else if (sub_index===4) {
      return(<span>{row.shop_name}</span>)
    } else if (sub_index===5) {
      return(<span>{row.purchase_order_no}</span>)
    } else if (sub_index===6) {
      return(<span>{row.po_status_text}</span>)
    } else if (sub_index===7) {
      return(<span>{this.renderItems(row.items)}</span>)
    } else if (sub_index===8) {
      return(<span>{row.description}</span>)
    } else if (sub_index===9) {
      return(
        <Select
          style={{background:(row.pr_status==='1'?'#5cb85c':row.pr_status==='2'?'#d9534f':'')}}
          options={[{label:'รออนุมัติ',value:'0'},{label:'อนุมัติ',value:'1'},{label:'ไม่อนุมัติ',value:'2'}]}
          value={row.pr_status}
          onChange={this.onPRStatusChange.bind(this,row.recordid)}
          clearable={false}
        />
      )
    } else if (sub_index===10) {
      return (<span><button onClick={this.onPrintClick.bind(this,row.recordid)} className='btn btn-default'><FontAwesome name='print' /></button></span>)
    }
  }

  render(){
    let {doc,showTable,activeKey} = this.state
    let tabsList = [
      {title:'รวมทั้งหมด',key:'all',loadOnShow:false},
      {title:'รออนุมัติ',key:'0',loadOnShow:true},
      {title:'อนุมัติ',key:'1',loadOnShow:true},
      {title:'ไม่อนุมัติ',key:'2',loadOnShow:true}
    ]
    let {messages} = this.props
    const headerTitles = [
      {title:messages['Day'],width:'150px'},
      {title:messages['Time'],width:'100px'},
      {title:messages['Requester'],width:'170px'},
      {title:messages['Approvers'],width:'170px'},
      {title:messages['Shop'],width:'150px'},
      {title:messages['PO No'],width:'150px'},
      {title:messages['PO Status'],width:'150px'},
      {title:messages['List'],width:'350px'},
      {title:messages['Description'],width:'350px'},
      {title:messages['Approved'],width:'150px'},
      {title:'',width:'50px'}             
    ]
    const searchOptions = [
      {
        label: messages['Requester'],
        value: 'request_by'
      },
      {
        label: messages['Approvers'],
        value: 'response_by'
      },
      {
        label: messages['Shop'],
        value: 'shop_name'
      },      
    ]
    return (
      <div>
        <Tabs
          style={{display:showTable?'block':'none'}} 
          activeKey={activeKey} 
          id="request-pr-tab" 
          onSelect={this.onTabsSelect.bind(this)}
        >
        {tabsList.map((item,index)=>
          <Tab 
            key={index}
            eventKey={index+1}
            title={item.title}
          >
            <div style={{display:showTable?'block':'none'}}>
              <ReportGeneralTable
                onRef={(ref)=>{this.qoTable[index] = ref}}
                title={messages['Request Purchase Order']} 
                txtTable={false}
                newTitle={messages['Add Request Purchase Order Item']}
                showPrintButton={false}
                headerTitles={headerTitles}
                bodyColumn={['added_date','added_date','request_by','response_by','shop_name','purchase_order_no','po_status_text','description','items','check','ref_po_no']}
                excludeClickColumn={['recordid']}
                searchOptions={searchOptions}          
                searchBy={'request_by'}
                loadData={this.loadData.bind(this)}
                onRenderColumn={this.onRenderColumn.bind(this)}
                onDocNew={this.onDocNew.bind(this)}
                isMobile={this.props.isMobile}
                mobileFieldMap={{title:'request_by',amount:'response_by',sub_title:{isArray:true,sub_title:'items',field:'description'},date:'',status:'',sub_status:''}}
                numberFormat={false}
                show={activeKey===index+1}
                loadFirst={activeKey===index+1}
                loadOnShow={item.loadOnShow}
                dataCount='total_count'
                callOut={this.props.callOut}
              />
            </div>
          </Tab> 
        )}  
        </Tabs>   
        <div>
          <StockRequestDoc 
            show={!showTable}
            doc={doc} 
            onClose={this.onDocClose.bind(this)}
            title={messages['Request Purchase Order List']}
          />
        </div>
      </div>
    )
  }
}

StockRequestReport.defaultProps = {
  show:false,
  callOut:false
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockRequestReport}),null,null,{withRef:true},
)(StockRequestReport);


// WEBPACK FOOTER //
// ./src/view/stock/StockRequestReport.js